import axios from '../plugins/axios'
import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'

const resource = 'api/v1/downlink'

export default {
    sendDownlinkResetBattery(idDevice: number): Promise<AxiosResponse<IServerResponse<void>>> {
        return axios.get(`${resource}/device/${idDevice}/reset_battery`)
    },
}
